const loadSubnav = () => {
  const subnavs = document.querySelectorAll('.subnav');

  if (subnavs.length) {
    const containsSubnav = document.querySelector('.contains-subnav');

    subnavs.forEach(subnav => {
      const subnavItems = Array.from(subnav.querySelectorAll('a'));
      const subnavItemsIndexes = subnavItems.map(item => item.getAttribute('data-index'));

      const observer = new IntersectionObserver(entries => {
        let atLeastOneIntersecting = false;
        entries.forEach(entry => {
          const id = entry.target.id;
          const index = subnavItemsIndexes.indexOf(id);

          if (entry.isIntersecting) {
            atLeastOneIntersecting = true;
            subnavItems.forEach(item => item.classList.remove('is-active'));
            subnavItems[index].classList.add('is-active');
          }
        });

        if (!atLeastOneIntersecting) {
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
          const clientHeight = document.documentElement.clientHeight || window.innerHeight;
          const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
          const scrolledToTop = scrollTop <= 0;

          if (scrolledToTop) {
            subnavItems.forEach(item => item.classList.remove('is-active'));
            subnavItems[0].classList.add('is-active');
          } else if (scrolledToBottom) {
            subnavItems.forEach(item => item.classList.remove('is-active'));
            const lastIndex = subnavItems.length - 1;
            subnavItems[lastIndex].classList.add('is-active');
          }
        }
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.25
      });

      containsSubnav.childNodes.forEach(child => {
        if (child.id) {
          observer.observe(child);
        }
      });

      subnavItems[0].classList.add('is-active');

      window.addEventListener('scroll', () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        const clientHeight = document.documentElement.clientHeight || window.innerHeight;
        const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
        const scrolledToTop = scrollTop <= 0;

        if (scrolledToTop) {
          subnavItems.forEach(item => item.classList.remove('is-active'));
          subnavItems[0].classList.add('is-active');
        } else if (scrolledToBottom) {
          subnavItems.forEach(item => item.classList.remove('is-active'));
          const lastIndex = subnavItems.length - 1;
          subnavItems[lastIndex].classList.add('is-active');
        }
      });
    });
  }
};

export default loadSubnav;
